import { Subject } from "rxjs";


/**
 * @public
 * @class
 * @name FilePublicDownload
 * @description
 *      This class is used to represent a File Descriptor or a Short File Descriptor which describes a file shared in a conversation (one-to-one or bubble).
 */
export class FilePublicDownload {

    url: string;
    fileName: string;
    totalBytes: number;
    receivedBytes: number;
    savePath: string;
    isCanceled: boolean;
    openFolderOnceDownloadFinished: boolean;

    progressSubject: Subject<any>;


    public static create(url: string, fileName: string, totalBytes: number, receivedBytes: number, savePath: string): FilePublicDownload {
        return new FilePublicDownload(url, fileName, totalBytes, receivedBytes, savePath);
    }

    /**
     * @this FilePublicDownload
     */
    constructor(url: string, fileName: string, totalBytes: number, receivedBytes: number, savePath: string) {
        /**
         * @public
         * @property {string} url The file descriptor url (File Descriptor only)
         * @readonly
         */
        this.url = url;

        /**
         * @public
         * @property {string} fileName The name of the file
         * @readonly
        */
        this.fileName = fileName;

        /**
         * @public
         * @property {string} totalBytes The totalBytes of the file
         * @readonly
        */
        this.totalBytes = totalBytes;

        /**
         * @public
         * @property {string} receivedBytes The receivedBytes of the file
         * @readonly
        */
        this.receivedBytes = receivedBytes;

        this.savePath = savePath;

        this.isCanceled = false;

        this.openFolderOnceDownloadFinished = false;

        this.progressSubject = new Subject<any>();
    }

    public isDownloadFinished() {
        return this.receivedBytes === this.totalBytes;
    }

    public askCancel() {
        this.isCanceled = true;
        this.progressSubject.next(undefined);
    }

}

